<template>
  <v-card>
    <v-navigation-drawer v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" app permanent>
      <v-list height="250">
        <v-list-item class="px-2">
          <v-list-item-avatar> </v-list-item-avatar>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item-group>
          <router-link style="text-decoration: none; color: inherit" to="/main">
            <v-list-item>
              <v-list-item-content class="ml-5">
                <v-list-item-title style="font-size: 14px"> หน้าหลัก </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon small>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </router-link>
          <v-divider></v-divider>
        </v-list-item-group>
        <v-divider></v-divider>
      </v-list>
      <template v-slot:append>
        <v-btn elevation="2" @click="onClickLogoff" outlined block large tile>ออกจากระบบ</v-btn>
        <v-divider></v-divider>
        <v-card elevation="0" class="d-flex justify-center pt-10">
          <v-btn icon href="https://www.facebook.com/technochon1985" target="_blank">
            <v-icon small class="mx-2">mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon small class="mx-2">mdi-music-note</v-icon>
          </v-btn>
          <v-btn icon href="https://www.instagram.com/bp.technochon/" target="_blank">
            <v-icon small class="mx-2">mdi-instagram</v-icon>
          </v-btn>
        </v-card>
        <v-card elevation="0" class="d-flex justify-center pb-10 pt-5">
          <p class="text-subtitle-2 text-center">Chonburi Technological College.</p>
        </v-card>
      </template>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
// import api from "@/services/api";
export default {
  name: "Menu",
  data() {
    return {
      emp_id: "",
      selectedMenu: 0,
      items: [],
    };
  },
  // async mounted() {
  //   await this.getmenuAlumni();
  // },
  methods: {
    // onClickMenu(route) {
    //   this.$router.push("/" + route).catch(() => {});
    // },
    onClickLogoff() {
      this.$store.dispatch("doLogout");
    },
    // async getmenuAlumni() {
    //   let result = await api.getmenu_alumni();
    //   console.log(result);
    // },
  },
};
</script>

<style></style>
